import React from "react";
import {InvoicesUIProvider} from "../components/InvoicesUIContext";
import { InvoicesLoadingDialog } from "../components/invoices-loading-dialog/InvoicesLoadingDialog";
import {InvoicesCard} from './InvoicesCard';

export function InvoicesPage() {
  const invoicesUIEvents = {};

  return (
    <InvoicesUIProvider invoicesUIEvents={invoicesUIEvents}>
      <InvoicesLoadingDialog />
      <InvoicesCard/>
    </InvoicesUIProvider>
  );
}
